//
// IMPORTANT: these should match exactly the layer names in Layer.java
//
export const FROM = 'FROM';
export const FROM_SAVED_QUERY = 'FROM_SAVED_QUERY';
export const SQL_FROM = 'SQL_FROM';
export const CSV_FROM = 'CSV_FROM';
export const WHERE = 'WHERE';
export const GROUP_BY = 'GROUP_BY'; // summarize as new column
export const ORDER_BY = 'ORDER_BY';
export const JOIN = 'JOIN';
export const CUSTOMIZE_AGGREGATE = 'CUSTOMIZE_AGGREGATE';
export const COLUMNS = 'COLUMNS';
export const EXPAND = 'EXPAND';
export const SELECT = 'SELECT';
export const ADD_COLUMN = 'ADD_COLUMN';
export const AGGREGATE = 'AGGREGATE'; // summarize
export const REARRANGE_COLUMNS = 'REARRANGE_COLUMNS';
export const RENAME_COLUMNS = 'RENAME_COLUMNS';

export const TEMPLATE = 'TEMPLATE'; // this is the template version of any of the above layers
